import * as React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// constants
import { Forms } from 'constants/index'
import { Modals } from 'constants/modals'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import { ReduxInput, ReduxSwitch } from 'components/FormElements/index'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// context
import { GroupSecurityContext } from 'containers/Security/components/GroupSecurity/layers/API'
// types
import { ISecurityGroup } from 'types/graphql'
// view components
import BusinessRule from './BusinessRule'
import DeleteButton from './BusinessRule/components/DeleteButton'
// views
import { BottomPaper, Form, Scrollbar } from 'themes/views/security'
// utils
import { required } from 'utils'

interface IIncomingProps {
  groupSecurity: ISecurityGroup
  hideModal: () => void
  isEdit: boolean
}

const GroupSecurityCreateForm: React.FC<InjectedFormProps & IIncomingProps> = ({
  groupSecurity,
  handleSubmit,
  hideModal,
  submitting,
  isEdit
}) => {
  const { deleteGroupSecurity } = React.useContext(GroupSecurityContext)

  const { showModal: showConfirmModal } = useShowModal({ modalType: Modals.CONFIRM_DELETE_MODAL })

  const handleDeleteGroupSecurity = () =>
    showConfirmModal({ handleConfirm: () => deleteGroupSecurity(groupSecurity.id, hideModal) })

  return (
    <Form onSubmit={handleSubmit} data-testid='group-security-form'>
      <Scrollbar>
        {isEdit && <DeleteButton iconSize={24} handleOnClick={handleDeleteGroupSecurity} />}
        <ReduxSwitch name={'active'} label={'Active'} reverse />
        <ReduxInput name={'name'} label={'Name'} validate={[required]} />
        <BusinessRule />
      </Scrollbar>

      <BottomPaper square>
        <Button type={'submit'} layout={BUTTON_LAYOUTS.PURPLE} isLoading={submitting}>
          {isEdit ? 'Save' : 'Create'}
        </Button>
        <Button layout={BUTTON_LAYOUTS.WHITE} type={'button'} onClick={hideModal}>
          Cancel
        </Button>
      </BottomPaper>
    </Form>
  )
}

export default reduxForm<any, any>({
  form: Forms.GROUP_SECURITY_CREATE_FORM,
  enableReinitialize: true
})(GroupSecurityCreateForm)
